import date from "@/utils/date";
import _ from "lodash";

export const showDates = [
  "showTomorrow",
  "showToday",
  "showYesterday",
  "showLastWeek",
  "showWeek",
  "showLastMonth",
  "showMonth",
];

export const makeDateRangeProps = () => {
  let props = {};
  showDates.forEach((item) => {
    props[item] = {
      type: Boolean,
      default() {
        return item != 'showTomorrow';
      },
    };
  });
  return props;
};

export const dateRangeMixins = {
  data() {
    return {
      items: [],
    };
  },
  props: {
    ...makeDateRangeProps(),
    value: [String, Object],
    maxDate: String,
    minDate: String,
    isAccountDate: Boolean,
  },
  computed: {
    isCross() {
      return date.hours() >= 12;
    },
    tomorrow() {
      return date.diffDate(1, this.today);
    },
    today() {
      if (!this.isAccountDate) {
        return date.today();
      }
      return this.isCross ? date.tomorrow() : date.today();
    },
    yesterday() {
      if (!this.isAccountDate) {
        return date.yesterday();
      }

      return this.isCross ? date.today() : date.yesterday();
    },
    dates() {
      let items = [
        {
          label: this.$t("component.date.picker.tomorrow"),
          name: "tomorrow",
          value: this.getRangeDate(this.tomorrow),
        },
        {
          label: this.$t("component.date.picker.today"),
          name: "today",
          value: this.getRangeDate(this.today),
        },
        {
          label: this.$t("component.date.picker.yesterday"),
          name: "yesterday",
          value: this.getRangeDate(this.yesterday),
        },
        {
          label: this.$t("component.date.picker.lastWeek"),
          name: "lastWeek",
          value: this.getLastWeek(),
        },
        {
          label: this.$t("component.date.picker.week"),
          name: "week",
          value: this.getWeek(),
        },
        {
          label: this.$t("component.date.picker.lastMonth"),
          name: "lastMonth",
          value: this.getLastMonth(),
        },
        {
          label: this.$t("component.date.picker.month"),
          name: "month",
          value: this.getMonth(),
        },
      ];
      return items.map((item) => {
        item.show = this["show" + _.upperFirst(item.name)];
        return item;
      });
    },
  },
  methods: {
    getWeek() {
      let weekDay = date.weekDay(this.today);
      let s = weekDay < 2 ? 2 - 7 - weekDay : 2 - weekDay;
      return this.getRangeDate(
        date.diffDate(s, this.today),
        date.diffDate(s + 6, this.today)
      );
    },
    getLastWeek() {
      let week = this.getWeek();
      return this.getRangeDate(
        date.diffDate(-7, week.startDate),
        date.diffDate(-1, week.startDate)
      );
    },
    getMonth() {
      let startOfMonth = date.startOfMonth(this.today);
      let endOfMonth = date.endOfMonth(this.today);
      return this.getRangeDate(startOfMonth, endOfMonth);
    },
    getLastMonth() {
      let month = this.getMonth();
      let lastDayOfLastMonth = date.diffDate(-1, month.startDate);

      return this.getRangeDate(
        date.startOfMonth(lastDayOfLastMonth),
        date.endOfMonth(lastDayOfLastMonth)
      );
    },
    getRangeDate(a, b) {
      if (!b) {
        b = a;
      }

      if (this.maxDate && date.isAfter(b, this.maxDate)) {
        b = this.maxDate;
      }

      if (this.minDate && date.isBefore(a, this.minDate)) {
        a = this.minDate;
      }

      return {
        startDate: a,
        endDate: b,
      };
    },
  },
};
